
/**
 * Powermail
 */
$(document).ready(function() {

    var $powermailForm = $(".powermail_form");

    // window.Parsley.on("form:error", function() {
    //     $.fn.matchHeight._update();
    // });
    window.Parsley.on("field:validated", function() {
        $.fn.matchHeight._maintainScroll = true;
        $.fn.matchHeight._update();
        $.fn.matchHeight._maintainScroll = false;
    });


    // -------------------------------------------------------------------------
    // Uploadfelder schön machen
    // Replacer erstellen
    // -------------------------------------------------------------------------

    var $powermailFile = $powermailForm.find(".powermail_file");

    $powermailFile.each(function () {
        upload = $(this);
        var replacer = '<span class="file-upload-replacer" data-replacefor="' + $(upload).attr('id') + '">' + $(upload).data('replacer_addfile') + '</span>';
        $(this).hide();
        $(upload).before(replacer);
    });


    // Wenn sich am echten Dateifeld was ändert, dann ändere auch den Replacer
    $powermailFile.change(function() {

        var $replacer = $('.file-upload-replacer[data-replacefor=' + $(this).attr('id') + ']');
        var filepath  = $(this).val();

        if (filepath !== "") {
            filepath = filepath.replace('C:\\fakepath\\', '');
            $replacer.addClass('active');
        } else {
            filepath = $(this).data('replacer_addfile');
           $replacer.removeClass('active');
        }

        // Schreibt den Dateinamen in den Replacer
        $replacer.html(filepath);

    });


    // Click auf das Replacer Element
    $('.file-upload-replacer').click(function (e) {

        // Wenn bereits eine Datei gewählt ist, wird diese nur gelöscht
        if ($(this).hasClass('active')) {
            e.preventDefault();
            var filepath = $('#' + $(this).data('replacefor')).data('replacer_addfile');
            $(this).html(filepath);
            $('#' + $(this).data('replacefor')).val('');
            $(this).removeClass('active');
        }
        // Das Original Element wird angeklickt
        else {
            $('#' + $(this).data('replacefor')).click();
        }
    });

});
